import { create } from 'zustand';

type SidebarState = {
	isMobileOpen: boolean;
	open: () => void;
	close: () => void;
	toggle: () => void;
};

export const useSidebarStore = create<SidebarState>((set) => ({
	isMobileOpen: false,
	open: () => set({ isMobileOpen: true }),
	close: () => set({ isMobileOpen: false }),
	toggle: () => set((state) => ({ isMobileOpen: !state.isMobileOpen })),
}));
